/*
 * ╔══════════════════════════════════════════════════════════════════════════════╗
 * ║                        HTTP 请求封装 — 完整流程图                                ║
 * ╚══════════════════════════════════════════════════════════════════════════════╝
 *
 *  httpGet / httpPost / httpPut / httpDelete / httpPatch
 *                         │
 *                         ▼
 *                 ┌───────────────┐
 *                 │  http(options) │
 *                 └───────┬───────┘
 *                         │
 *                         ▼
 *              ┌─────────────────────┐    是
 *              │ isRefresh 正在刷新？ ├────────────┐
 *              └──────────┬──────────┘           │
 *                    否   │                      ▼
 *                         │           ┌──────────────────────┐
 *                         │           │ 挂起请求，加入等待队列    │
 *                         │           │ (resolveList/rejectList)│
 *                         │           └──────────┬───────────┘
 *                         │                      │ 等待刷新完成后继续
 *                         │◄─────────────────────┘
 *                         ▼
 *              ┌──────────────────────┐
 *              │ Sign.signAuth(options)│  边缘计算签名
 *              └──────────┬───────────┘
 *                         ▼
 *              ┌──────────────────────┐    否
 *              │ refresh_token 存在？  ├──────────────────────────────────┐
 *              └──────────┬───────────┘                                  │
 *                    是   │                                              │
 *                         ▼                                              │
 *              ┌──────────────────────┐    是                            │
 *              │ 长token(refresh)过期？├────────┐                         │
 *              └──────────┬───────────┘        ▼                        │
 *                    否   │          ┌───────────────────┐               │
 *                         │          │ logout() 清除信息  │               │
 *                         │          │ 弹窗 → 跳转登录页  │                │
 *                         │          │ reject({code:401}) │             │
 *                         │          └───────────────────┘              │
 *                         ▼             (流程终止 ✘)                     │
 *              ┌──────────────────────┐                                 │
 *              │ 短token(access)过期？ │                                  │
 *              └──────────┬───────────┘                                 │
 *                    否   │   是                                         │
 *                    │    │   ▼                                         │
 *                    │    │  ┌────────────────────────┐                 │
 *                    │    │  │ isRefresh = true        │                │
 *                    │    │  │ refreshShortToken()     │                │
 *                    │    │  └───────────┬────────────┘                 │
 *                    │    │         ┌────┴────┐                         │
 *                    │    │      成功│        │失败                      │
 *                    │    │         ▼        ▼                         │
 *                    │    │  ┌──────────┐ ┌──────────────┐             │
 *                    │    │  │执行等待队列│ │执行拒绝队列     │             │
 *                    │    │  │resolveList│ │rejectList   │             │
 *                    │    │  └──────────┘ │logout()      │             │
 *                    │    │               │弹窗→跳转登录页  │             │
 *                    │    │               └──────────────┘             │
 *                    │    │         │ finally: isRefresh = false        │
 *                    │    │◄────────┘                                   │
 *                    │    │                                             │
 *                    ▼    ▼                                             │
 *              ┌──────────────────────┐                                 │
 *              │ 设置 Authorization    │                                 │
 *              │ 请求头(Bearer token)  │                                 │
 *              └──────────┬───────────┘                                 │
 *                         │◄────────────────────────────────────────────┘
 *                         ▼
 *              ┌──────────────────────┐
 *              │   uni.request 发送    │  timeout: 20s
 *              └──────────┬───────────┘
 *                    ┌────┴────┐
 *                 成功│        │失败(网络错误)
 *                    ▼        ▼
 *                    │   ┌────────────────────┐
 *                    │   │ Toast: 网络错误      │
 *                    │   │ reject({code:404}) │
 *                    │   └────────────────────┘
 *                    ▼          (流程终止 ✘)
 *          ┌─────────────────┐
 *          │ HTTP statusCode? │
 *          └────┬────┬───┬───┘
 *          2xx  │    │   │ 其他
 *               │  401   │
 *               ▼    │   ▼
 *     ┌──────────┐   │  ┌──────────────────┐
 *     │业务code？ │   │  │ errorHandler()   │
 *     └┬──┬──┬──┬┘   │  │ Toast 错误信息     │
 *      │  │  │  │    │  │ reject(errorData) │
 *   -1 │ 900 902│默认 │  └──────────────────┘
 *      ▼  ▼  ▼  ▼    ▼
 *  ┌──────┐│ │ ┌───┐┌──────────────────┐
 *  │Toast ││ │ │   ││logout()          │
 *  │错误  ││ │ │ R ││跳转登录页          │
 *  │信息  ││ │ │ E ││Toast 错误信息      │
 *  └──────┘│ │ │ S ││reject(res.data)  │
 *     ┌────┘ │ │ O │└──────────────────┘
 *     ▼      ▼ │ L │
 *  ┌──────────┐│ V │
 *  │navigateBack│ E │
 *  │返回上一页 ││   │
 *  └──────────┘│(data)│
 *     ▲  Toast │   │
 *     │  +返回 │ ✔ │
 *     └────────┘   │
 *                  ▼
 *            请求成功返回 ✔
 */

import type { CustomRequestOptions } from '@/interceptors/request'
import { Sign } from '@/interceptors/signAuth'
import { useUserStore } from '@/store'
import { errorHandler, executeFunctionsInBatches, logHttpError } from '@/utils/httpHelper'
import { ShowMessage } from '@/utils/request/enum'
import { navigateBack } from '@/utils/utilities'

/**
 * 下面所提到的长token为有效期更长的token
 */

// 是否正在刷新短token
let isRefresh = false

// 存放刷新刷新短token期间的请求的回调
const resolveList: Array<() => void> = []

const rejectList: Array<() => void> = []

export async function http<T>(options: CustomRequestOptions) {
  if (isRefresh) {
    await new Promise((resolve, reject) => {
      resolveList.push(resolve as () => void)
      rejectList.push(reject as () => void)
    })
  }

  // 边缘计算签名
  Sign.signAuth(options)

  const userStore = useUserStore()

  // 判断长期token是否过期
  if (userStore.tokenInfo.refresh_token_expires_in !== 0 && userStore.tokenInfo.refresh_token) {
    // 判断长token是否过期，如果过期，直接跳转重新登录
    if (new Date().getTime() >= userStore.tokenInfo.refresh_token_expires_in) {
      // 清除失效信息
      userStore.logout()
      uni.showModal({
        title: '登录过期',
        content: '前往登录页面',
        showCancel: false,
        success(res) {
          if (res.confirm) {
            uni.redirectTo({ url: import.meta.env.VITE_LOGIN_URL })
          }
          else if (res.cancel) {
            console.log('用户点击取消')
          }
        },
      })
      const errorData = { code: 401, message: '登录过期' } as IRejectData
      logHttpError(options, errorData, {
        code: errorData.code,
        message: errorData.message,
        statusCode: 401,
      })
      return Promise.reject(errorData)
    }
    else if (new Date().getTime() >= userStore.tokenInfo.expires_in) {
      isRefresh = true
      // 长token未过期，短token过期，刷新短token
      await userStore.refreshShortToken().then(() => {
        // 继续执行被搁置的请求
        executeFunctionsInBatches(resolveList)
      }).catch((err) => {
        logHttpError(options, err, { message: 'refresh short token failed' })
        // 短token刷新失败，重新登录
        executeFunctionsInBatches(rejectList)
        // 清除失效信息
        userStore.logout()
        uni.showModal({
          content: '登录过期，前往登录页面',
          showCancel: false,
          success(res) {
            if (res.confirm === true) {
              uni.redirectTo({ url: import.meta.env.VITE_LOGIN_URL })
            };
          },
        })
      }).finally(() => {
        isRefresh = false
      })
    }

    // 长短token均未过期，携带请求头携带token
    if (options.header) {
      // console.log('设置Authorization1')
      options.header.Authorization = `${userStore.tokenInfo.token_type} ${userStore.tokenInfo.access_token}`
      // options.header['content-type'] = 'application/x-www-form-urlencoded'
    }
    else {
      // console.log('设置Authorization2')
      options.header = {
        // access_token:`${userStore.tokenInfo.token_type} ${userStore.tokenInfo.access_token}`,
        Authorization: `${userStore.tokenInfo.token_type} ${userStore.tokenInfo.access_token}`,
        // Authorization: ``
        // 'content-type' :'application/x-www-form-urlencoded'
      }
    }
  }

  // 1. 返回 Promise 对象
  return new Promise<IResData<T>>((resolve, reject) => {
    uni.request({
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      timeout: 20 * 1000,
      // 响应成功
      success(res) {
        // 状态码 2xx，参考 axios 的设计
        if (res.statusCode >= 200 && res.statusCode < 300) {
          // 2.1 提取核心数据 res.data
          const backData: IResData<T> = res.data as IResData<T>

          switch (backData.code) {
            case -1: {
              logHttpError(options, backData, {
                code: backData.code,
                message: backData.message,
                statusCode: res.statusCode,
              })
              !options.hideErrorToast
              && uni.showToast({
                icon: 'none',
                title: ((res.data as IResData<T>).message || ShowMessage(backData.code)),
              })
              break
            }
            case 900: {
              // code 900,返回上一级页面
              setTimeout(() => {
                navigateBack()
              }, 1000)
              break
            }
            case 902: {
              logHttpError(options, backData, {
                code: backData.code,
                message: backData.message,
                statusCode: res.statusCode,
              })
              // code 902,弹报错信息后，返回上一级页面
              !options.hideErrorToast
              && uni.showToast({
                icon: 'none',
                title: ((res.data as IResData<T>).message || ShowMessage(backData.code)),
              })
              setTimeout(() => {
                navigateBack()
              }, 1500)
              break
            }
            default:
              resolve(backData as IResData<T>)
              break
          }
        }
        else if (res.statusCode === 401) {
          logHttpError(options, res.data, {
            message: (res.data as IResData<T>)?.message || ShowMessage(res.statusCode),
            statusCode: res.statusCode,
          })
          // 401错误  -> 清理用户信息，跳转到登录页
          userStore.logout()
          uni.redirectTo({ url: import.meta.env.VITE_LOGIN_URL })
          !options.hideErrorToast
          && uni.showToast({
            icon: 'none',
            title: ((res.data as IResData<T>).message || ShowMessage(res.statusCode)),
          })
          reject(res.data)
        }
        else {
          const errorData = errorHandler(res)
          logHttpError(options, errorData, {
            code: errorData.code,
            message: errorData.message,
            statusCode: errorData.statusCode,
          })

          // 其他错误 -> 根据后端错误信息轻提示
          !options.hideErrorToast
          && uni.showToast({
            icon: 'none',
            title: errorData.message,
          })
          reject(errorData)
        }
      },
      // 响应失败
      fail(err) {
        !options.hideErrorToast
        && uni.showToast({
          icon: 'none',
          title: '网络错误，换个网络试试',
        })
        const errorData: IRejectData = {
          statusCode: 404,
          code: 404,
          message: err.errMsg,
          data: null,
        }
        logHttpError(options, errorData, {
          code: errorData.code,
          message: errorData.message,
          statusCode: errorData.statusCode,
        })
        reject(errorData)
      },
    })
  })
}

/**
 * GET 请求
 * @param url 后台地址
 * @param query 请求query参数
 * @param header 请求头，默认为json格式
 * @returns
 */
export function httpGet<T>(url: string, query?: Record<string, any>, header?: Record<string, any>, options?: Partial<CustomRequestOptions>) {
  return http<T>({
    url,
    query,
    method: 'GET',
    header,
    ...options,
  })
}

/**
 * POST 请求
 * @param url 后台地址
 * @param data 请求body参数
 * @param query 请求query参数，post请求也支持query，很多微信接口都需要
 * @param header 请求头，默认为json格式
 * @returns
 */
export function httpPost<T>(url: string, data?: Record<string, any>, query?: Record<string, any>, header?: Record<string, any>, options?: Partial<CustomRequestOptions>) {
  return http<T>({
    url,
    query,
    data,
    method: 'POST',
    header,
    ...options,
  })
}
/**
 * PUT 请求
 */
export function httpPut<T>(url: string, data?: Record<string, any>, query?: Record<string, any>, header?: Record<string, any>, options?: Partial<CustomRequestOptions>) {
  return http<T>({
    url,
    data,
    query,
    method: 'PUT',
    header,
    ...options,
  })
}

/**
 * DELETE 请求（无请求体，仅 query）
 */
export function httpDelete<T>(url: string, query?: Record<string, any>, header?: Record<string, any>, options?: Partial<CustomRequestOptions>) {
  return http<T>({
    url,
    query,
    method: 'DELETE',
    header,
    ...options,
  })
}

/**
 * PATCH 请求
 */
export function httpPatch<T>(url: string, data?: Record<string, any>, query?: Record<string, any>, header?: Record<string, any>, options?: Partial<CustomRequestOptions>) {
  return http<T>({
    url,
    data,
    query,
    // eslint-disable-next-line ts/ban-ts-comment
    // @ts-ignore  //此处如果进行类型拓展，会导致传入uni.request的参数报错。
    method: 'PATCH',
    header,
    ...options,
  })
}

http.get = httpGet
http.post = httpPost
http.put = httpPut
http.delete = httpDelete
http.patch = httpPatch
